module.exports = __webpack_public_path__ + "static/media/medium.5f76b31b.svg";